const API = {
  GET_SCHEDULES: {
    path: '/session/schedule',
    method: 'GET',
  },
  GET_SESSION_URL: {
    path: '/meeting/generate-signed-url',
    method: 'POST',
  },
  POST_CANCEL_SESSION: {
    path: '/session/cancel',
    method: 'POST',
  },
};
export default API;
